import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export interface IKeywordAnalysisCardProps {
  keyword: string;
  searchCountTotal: number;
  combinedScore: number;
  reviewMentionCount: number;
  reason: string;
  showDetailButton?: boolean;
  onDetailClick?: () => void;
}

export const KeywordAnalysisCard: React.FunctionComponent<
  IKeywordAnalysisCardProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.keywordAnalysis.${key}`);

  const {
    keyword,
    searchCountTotal,
    combinedScore,
    reviewMentionCount,
    reason,
    showDetailButton = false,
    onDetailClick,
  } = props;

  const [isDetailExpanded, setIsDetailExpanded] = useState(false);

  const handleToggleDetail = () => {
    if (onDetailClick) {
      onDetailClick();
    } else {
      setIsDetailExpanded(!isDetailExpanded);
    }
  };

  return (
    <div className="white-border-panel keyword-analysis-card">
      <div className="keyword-analysis-header">
        <h3 className="keyword-analysis-title">{t("suggestedKeyword")}</h3>
      </div>

      <div className="keyword-analysis-keyword">{keyword}</div>

      <div className="keyword-analysis-metrics">
        <div className="metric-item">
          <div className="metric-value">
            {searchCountTotal.toLocaleString()}
          </div>
          <div className="metric-label">{t("searchCountTotal")}</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{combinedScore.toLocaleString()}</div>
          <div className="metric-label">{t("combinedScore")}</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">
            {reviewMentionCount.toLocaleString()}
          </div>
          <div className="metric-label">{t("reviewMentionCount")}</div>
        </div>
      </div>

      <div className="keyword-analysis-reason">
        <div className="reason-text">{reason}</div>
      </div>

      {showDetailButton && (
        <div className="keyword-analysis-footer">
          <button className="btn btn-blue" onClick={handleToggleDetail}>
            {t("seeDetail")}
          </button>
        </div>
      )}
    </div>
  );
};

export default KeywordAnalysisCard;
